<ui-grid
    [config]="config"
    [data]="valorDadosConsulta"
    [meta]="meta"
    (metaChanged)="metaChanged.emit($event)"
    [limitarAlturaMaxima]="limitarAlturaMaxima"
>
</ui-grid>
